define(["dojo-proxy-loader?name=dojo/_base/kernel!/home/jenkins/agent/workspace/mailchimp-cd/MC-Mono-Build/node_modules/@mc/webpack-plugin-legacy-dojo/src/modules/noop-module", "./text"], function (dojo) {
  // module:
  //		dojo/cache

  // dojo.cache is defined in dojo/text
  return dojo.cache;
});